module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "showClose": false,
      "isBgOverlay": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__header__right"
  }, [_c('button', {
    staticClass: "do-bttn no-print",
    on: {
      "click": _vm.print
    }
  }, [_c('span', {
    staticClass: "icon-printer3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle no-print",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content",
    attrs: {
      "id": "printUserSalaryTable"
    }
  }, [_c('h4', {
    staticClass: "only-print"
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('div', {
    staticClass: "salarySubsPerfUserTable"
  }, _vm._l((_vm.tables), function(table) {
    return _c('div', {
      key: table.employmentId
    }, [_c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          onShow: _vm.hideTippy,
          trigger: 'manual',
          arrow: true,
          placement: 'top',
          zIndex: 2147483010
        }),
        expression: "{\n                                  onShow: hideTippy,\n                                  trigger: 'manual',\n                                  arrow: true,\n                                  placement : 'top',\n                                  zIndex: 2147483010\n                                }"
      }],
      staticClass: "do-bttn do-copy-bttn no-print marg-1-bottom width-100",
      attrs: {
        "content": 'Kopieret tabel for ' + table.title
      },
      on: {
        "click": function($event) {
          return _vm.copyTableDayCounts(table, $event)
        }
      }
    }, [_vm._v("\n            Kopier tabel for " + _vm._s(table.title) + "\n          ")]), _vm._v(" "), _c('table', {
      staticClass: "d-table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(table.title))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(table.minutes))])])]), _vm._v(" "), _c('tbody', _vm._l((table.dates), function(date, index) {
      return _c('tr', {
        key: index
      }, [_c('td', [_vm._v(_vm._s(date.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(date.dayCount))])])
    }), 0)])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-488a89ef!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySubsPerfUserTable.vue
// module id = 1581
// module chunks = 1